export enum TicketOperationStatus {
    NEW = "New",
    IN_PROGRESS = "InProgress",
    RESOLVED = "Resolved",
    UNRESOLVED = "Unresolved",
    ON_HOLD = "OnHold"
}
